<template>
    <div class="notificationsPage d-flex flex-column">

        <h2 class="p-3 border-bottom-light">Notifications</h2>

        <div class="">
            <div class="col-sm-12 d-flex align-items-center justify-content-between my-3">
                <div class="p-0">
                    <v-select :value="selectedNotificationType" label="description" :options="notificationTypes" @input="filterTypeChanged"></v-select>
                </div>

                <div class="d-flex align-items-center">
                    <button type="button" class="btn action mr-3" @click="askDeleteAllNotifications">
                        Delete all
                    </button>
                    <button type="button" class="btn tertiary mr-3" @click="markAllNotificationsRead">
                        Mark all as read
                    </button>

                </div>
            </div>
        </div>

        <div v-if="isLoadingNotifications" class="dark text-center">
            <loader></loader>
        </div>

        <div v-else class="yScroll pb-3">

                <div class="col-sm-12 d-flex justify-content-end my-4">
                    <uib-pagination
                        v-if="pageInfo && pageInfo.pageCount > 1"
                        v-model="pagination"
                        :total-items="pageInfo.totalItemCount"
                        :items-per-page="pagination.pageSize"
                        :boundary-link-numbers="false"
                        :max-size="7"
                        @change="paginationChanged()">
                    </uib-pagination>
                </div>

                <div class="col-sm-12 my-4">
                    <notification class="border-bottom-medium" v-for="notification in currentNotifications" :key="notification.id" :notification="notification"></notification>
                </div>

                <div class="col-sm-12 d-flex justify-content-end my-4">
                    <uib-pagination
                        v-if="pageInfo && pageInfo.pageCount > 1"
                        v-model="pagination"
                        :total-items="pageInfo.totalItemCount"
                        :items-per-page="pagination.pageSize"
                        :boundary-link-numbers="false"
                        :max-size="7"
                        @change="paginationChanged()">
                    </uib-pagination>
                </div>

            <div v-if="isLoadingNotifications" class="text-center w-100">
                <loader />
            </div>

            <div v-else-if="currentNotifications && currentNotifications.length < 1" class="text-center dark p-4">
                No notifications
            </div>
        </div>

    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import {mapGetters, mapActions} from 'vuex'
import Notification from '@/components/common/notifications/default'
import Loader from '@/tools/loaders/loader1'

export default {
    data: function() {
        return {
            isLoadingNotifications: false,
            fetchedNotifications: null,
            pagination:{
                currentPage: 1,
            },
            selectedNotificationType: {
                description: 'All',
                id: null
            },

        }
    },
    created: function() {
        this.markAllNotificationsRead()
        this.downloadNotifications()
    },
    computed:{
        ...mapGetters([
            'getNotificationTypes',
            'account'
        ]),
        currentNotifications: function () {
            return this.fetchedNotifications? this.fetchedNotifications.result : []
        },
        pageInfo: function () {
            return this.fetchedNotifications? this.fetchedNotifications.pageInfo : []
        },
        fetchObject: function() {
            return {
                pagination: this.pagination,
                search: {
                    type: this.selectedNotificationType.id
                }
            }
        },
        notifications: function() {
            return this.currentNotifications && this.currentNotifications.result? this.currentNotifications.result : [];
        },
        notificationTypes: function() {
            let typeAll = [
                {
                    description: 'All',
                    id: null
                }
            ];

            return typeAll.concat(this.getNotificationTypes);
        },
    },
    methods:{
        ...mapActions([
            'fetchNotifications',
            'markNotificationAsRead',
            'refreshAccountData',
            'markAllNotificationsRead',
            'markAllNotificationsViewed',
            'deleteAllnotifications',
            'markAllNotificationsRead'
        ]),
        downloadNotifications: function () {
            this.isLoadingNotifications = true
            this.fetchNotifications(this.fetchObject).then(response => {
                this.isLoadingNotifications = false
                // mark downloaded notifications as viewed
                this.fetchedNotifications = response
            }).catch(error => {
                this.isLoadingNotifications = false
            })
        },
        paginationChanged: function (e) {
            this.downloadNotifications()
        },
        filterTypeChanged: function (e) {
            if(e.id != this.selectedNotificationType.id){
                this.selectedNotificationType = e
                // this.$set(this.pagination.search, 'type', e.id)
                console.log('pagination', this.pagination);
                this.downloadNotifications()

            }
        },
        askDeleteAllNotifications: function () {
            this.$dialog.confirm('\
            <div class="fs-larg font-weight-600 mb-4">Delete <b>all</b> notifications?</div>\
            <div>This cannot be undone!</div>')
            .then(() => {
                this.deleteAllnotifications().then(response => {
                    this.downloadNotifications()
                })
            })
            .catch(function () {
            });
        },
        dismissAlert: function(notification){
            this.markNotificationAsRead(notification);
        },
    },
    components:{
        vSelect: extendedVSelect,
        Notification,
        Loader
    }
}
</script>

<style scoped lang="scss">
    @import '../../assets/scss/_variables.scss';
    .notificationsPage{
        // height: 94vh;
        // position: relative !important;
        // z-index: 1;
    }

    .yScroll{
        height: inherit;
        overflow-y: auto;
    }

</style>



// WEBPACK FOOTER //
// Notifications.vue?dfb88a5e